import { render } from "./signAdd.vue?vue&type=template&id=003ab6c2&ts=true"
import script from "./signAdd.vue?vue&type=script&lang=ts"
export * from "./signAdd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__